import MainBenefits from "@/components/tabs/overview/MainBenefits";
import Features from "@/components/tabs/overview/Features";
import ExtraFeatures from "@/components/tabs/overview/ExtraFeatures";
import Testimonials from "@/components/tabs/overview/Testimonials";
import Influencers from "@/components/tabs/overview/Influencers";
import UserVideos from "@/components/tabs/overview/UserVideos";
import FaqSection from "@/components/tabs/overview/FaqSection";
import Plans from "@/components/tabs/overview/Plans";
import Benefits from "./overview/Benefits";
import PainPoints from "./overview/PainPoints";
import Solution from "./overview/Solution";
import Intro from "./overview/Intro";
import Platforms from "./overview/Platforms";
import VideoFeatures from "./overview/VideoFeatures";
import PurchaseSteps from "./overview/PurchaseSteps";
import UserMap from "./overview/UserMap";
import { useTranslation } from "react-i18next";
import AboutSection from "./overview/AboutSection";

interface OverviewProps {
  onPurchase: (planId: string) => void;
}

const Overview = ({ onPurchase }: OverviewProps) => {

  const { i18n } = useTranslation();

  return (
    <div className="space-y-4 md:space-y-8">
      {/* <div className="w-px h-12 bg-slate-400 mx-auto"></div> */}
      <Intro />
      <PainPoints />
      <MainBenefits />
      <Benefits onPurchase={onPurchase} />
      {/* <Solution onPurchase={onPurchase} /> */}
      <VideoFeatures onPurchase={onPurchase} />

      <Testimonials onPurchase={onPurchase} />
      <UserMap />

      <Plans onPurchase={onPurchase} titleKey="purchase.title-promo" subtitleKey="purchase.subtitle-promo" />
      <PurchaseSteps onPurchase={onPurchase} />

      <UserVideos onPurchase={onPurchase} />

      <Features />
      <ExtraFeatures onPurchase={onPurchase} />

      <Influencers layout="carousel" onPurchase={onPurchase} />

      <Platforms />
      <PurchaseSteps onPurchase={onPurchase} />
      <Plans onPurchase={onPurchase} />

      <FaqSection />
      <AboutSection />
    </div>
  );
};

export default Overview;
